import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedServiceService } from 'app/services/shared-service.service';
import { Observable, from } from 'rxjs';
import {FormBase} from '@vendor/shared-component/dynamicForm/dynamic-form/form-base';
import {SettingService} from 'app/components/setting/setting.service';
import {SnackBarComponent} from '@vendor/shared-component/snack-bar/snack-bar.component';
@Component({
  selector: 'app-polling-form',
  templateUrl: './polling-form.component.html',
  styleUrls: ['./polling-form.component.scss']
})
export class PollingFormComponent implements OnInit {
  showForm = false;
  pollingForm;
  isLoading = false;
  sections$: Observable<FormBase<any>[]>;
  formId;
  title = '';
  @ViewChild(SnackBarComponent) snackBar: SnackBarComponent;
  constructor(private sharedService: SharedServiceService, private service: SettingService) { }

  ngOnInit(): void {
    this.checkForm();
  }
  checkForm() {
    this.service.getSurveyForm().subscribe(res => {
      if (res.code === 0) {
        if (res.content.form.enabled) {
          this.formId = res.content.form.id;
          this.title = res.content.form.title;
          this.sections$ = res.content.form.sections;
          this.pollingForm = JSON.parse(localStorage.getItem('pollingForm'));
          if (this.pollingForm && this.pollingForm.formId === this.formId) {
            const date = new Date(this.pollingForm.date);
            const dayDiff = (Number(new Date()) - date.getTime()) / (24 * 60 * 60 * 1000);
            if (dayDiff > 14) {
              this.showForm = true;
              this.checkPopUpBottom();
            }
          } else {
            this.pollingForm = {
              date: new Date(),
              formId: this.formId
            };
            localStorage.setItem('pollingForm', JSON.stringify(this.pollingForm));
            this.showForm = true;
            this.checkPopUpBottom();
          }
        }
      }
    });
  }
  checkPopUpBottom() {
    setTimeout(() => this.sharedService.handlePopupBottom(), 2);
  }
  closePopup() {
    this.showForm = false;
    this.checkPopUpBottom();
    this.pollingForm.date = new Date();
    localStorage.setItem('pollingForm', JSON.stringify(this.pollingForm));
  }
  onFormSubmit({payload}) {
    this.isLoading = true;
    let flatedArr = [];
    for (const item of payload) {
      if (item !== undefined) {
        // tslint:disable-next-line:only-arrow-functions
        const x = Object.keys(item).map(function(key) {
          return {key, value: item[key]};
        });
        flatedArr.push(x);
      }
    }
    flatedArr = [].concat(...flatedArr);
    const answersObj = {
      answers: flatedArr,
      formId: this.formId
    };
    this.service.postUserForms(answersObj)
      .subscribe(res => {
        this.isLoading = false;
        if (res.code === 0) {
          this.snackBar.addSnack('نظر شما با موفقیت ثبت شد.', true);
          this.closePopup();
        } else {
          this.snackBar.addSnack(res.message, true);
        }
      },
      err => {
        this.isLoading = false;
        this.snackBar.addSnack(err.message, true);
      });
  }
}
